import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=52ebb506&scoped=true"
import script from "./OrderListItem.vue?vue&type=script&lang=js"
export * from "./OrderListItem.vue?vue&type=script&lang=js"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=52ebb506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebb506",
  null
  
)

export default component.exports